import { render, staticRenderFns } from "./VisitaPhoto.vue?vue&type=template&id=28a3418a&scoped=true"
import script from "./VisitaPhoto.vue?vue&type=script&lang=js"
export * from "./VisitaPhoto.vue?vue&type=script&lang=js"
import style0 from "./VisitaPhoto.vue?vue&type=style&index=0&id=28a3418a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3418a",
  null
  
)

export default component.exports